"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createMuiThemeFromEmotionTheme = void 0;
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _react = _interopRequireDefault(require("react"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _utils = require("./utils");
var _styles = require("@mui/material/styles");
var _withTheme = _interopRequireDefault(require("./with-theme"));
var _fromTheme = _interopRequireDefault(require("./from-theme"));
const convertToNumber = key => (0, _parseInt2.default)(key.replace('px', ''), 10);

/**
 * Creates a material-ui theme using values from an emotion theme.
 * @function
 * @param {Object} theme - The Emotion theme object to use.
 * @param {Object} [overrides={}] - Pass overrides key to MUI theme.
 *     https://material-ui.com/customization/themes/#css
 * @returns {Object}
 */
const createMuiThemeFromEmotionTheme = (theme, overrides) => {
  const themed = key => (0, _fromTheme.default)(key)({
    theme
  });
  const colorProvidermatch = themed('color_providermatch');
  const colorProvidermatchSecondary = themed('color_providermatch_secondary');
  const colorDanger = themed('color_danger');
  const colorDangerSecondary = themed('color_danger_secondary');
  const providermatchPalette = {
    50: colorProvidermatchSecondary,
    100: colorProvidermatchSecondary,
    200: colorProvidermatch,
    300: colorProvidermatch,
    400: colorProvidermatch,
    500: colorProvidermatch,
    600: colorProvidermatch,
    700: colorProvidermatch,
    800: colorProvidermatch,
    900: colorProvidermatch,
    A100: colorProvidermatchSecondary,
    A200: colorProvidermatch,
    A400: colorProvidermatch,
    A700: colorProvidermatch,
    contrastDefaultColor: 'light'
  };
  const muiTheme = (0, _styles.createTheme)((0, _styles.adaptV4Theme)({
    palette: {
      primary: providermatchPalette,
      secondary: providermatchPalette,
      error: {
        50: colorDangerSecondary,
        100: colorDangerSecondary,
        200: colorDanger,
        300: colorDanger,
        400: colorDanger,
        500: colorDanger,
        600: colorDanger,
        700: colorDanger,
        800: colorDanger,
        900: colorDanger,
        A100: colorDangerSecondary,
        A200: colorDanger,
        A400: colorDanger,
        A700: colorDanger,
        contrastDefaultColor: 'light'
      }
    },
    typography: {
      fontFamily: themed('font_face'),
      fontSize: convertToNumber(themed('font_size')),
      caption: {
        fontSize: convertToNumber(themed('font_size'))
      },
      fontWeightLight: themed('font_weight_light'),
      fontWeightRegular: themed('font_weight'),
      fontWeightMedium: themed('font_weight_bold'),
      button: {
        fontSize: convertToNumber(themed('font_size')),
        fontWeight: themed('font_weight_bold'),
        fontFamily: themed('font_face'),
        textTransform: 'none'
      }
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: (0, _parseInt2.default)(themed('screen_small').replace('px', ''), 10),
        md: (0, _parseInt2.default)(themed('screen_medium').replace('px', ''), 10),
        lg: (0, _parseInt2.default)(themed('screen_large').replace('px', ''), 10),
        xl: (0, _parseInt2.default)(themed('screen_large').replace('px', ''), 10)
      },
      unit: 'px',
      step: 5
    },
    shape: {
      borderRadius: themed('border_radius')
    }
  }));
  return {
    ...muiTheme,
    components: overrides
  };
};
exports.createMuiThemeFromEmotionTheme = createMuiThemeFromEmotionTheme;
let createMuiTheme = createMuiThemeFromEmotionTheme;
if (!(0, _utils.isServerSide)()) {
  // memo-ization is only safe client side. If used in server-side-rendering it will cause a memory leak
  createMuiTheme = (0, _memoize2.default)(createMuiThemeFromEmotionTheme, function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _stringify.default)(args);
  });
}

/**
 * Supplies a material-ui theme context to the component,
 * using values from the current emotion theme.
 * @param MuiComponent - The material-ui component to modify.
 * @param {Function} [overrides] - Function that takes a theme param and
 *     should return an object which will be passed into the MUI theme under
 *     the overrides key. https://material-ui.com/customization/themes/#css
 * @returns {React.Component}
 */
const withMuiThemeAdapter = function (MuiComponent) {
  let overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => ({});
  const wrapped = (0, _withTheme.default)(_ref => {
    let {
      theme,
      ...props
    } = _ref;
    const muiTheme = createMuiTheme(theme, overrides(theme));
    return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
      theme: muiTheme
    }, /*#__PURE__*/_react.default.createElement(MuiComponent, props));
  });
  let componentName = MuiComponent.displayName || MuiComponent.name || 'Component';
  wrapped.displayName = `KyruusMuiThemeAdapted(${componentName})`;
  return wrapped;
};
var _default = exports.default = withMuiThemeAdapter;